import { combineReducers } from 'redux';
import auth from 'store/auth/reducer';
import app from 'store/app/reducer';
import remoteConfig from 'store/remoteConfig/reducer';

import mobileVerification from './mobileVerification/reducer';
import userPortfolio from './userPortfolio/reducer';
import emailVerification from './emailVerification/reducer';

const createRootReducer = () =>
  combineReducers({
    appReducer: app,
    auth,
    mobileVerification,
    emailVerification,
    remoteConfig,
    userPortfolio,
  });

export default createRootReducer;
